export const SERVICE_OPTIONS = [
  "Консультация (тема, структура, журнал, стратегия публикации) / Кеңес беру (тақырып, құрылым, журнал, жариялау стратегиясы)",
  "Академическое и языковое редактирование вашей готовой рукописи / Дайын мақалаңызға академиялық/тілдік редакциялау",
  "Оформление вашей готовой рукописи по требованиям журнала (стиль, ссылки, таблицы, рисунки) / Дайын мақаланы журнал талаптарына сай рәсімдеу",
  "Перевод / научный перевод (KZ/RU/ENG) / Аударма / ғылыми аударма (KZ/RU/ENG)",
  "Подбор журнала и подготовка полного пакета файлов для подачи вашей готовой статьи в журнал",
  "Сопровождение ответа рецензентам и переписки с редакцией",
  "Заказать работу с нуля и полное сопровождение / Жұмысты нөлден бастап толық сүйемелдеумен тапсырыс беру",
  "Пока только интересуюсь, хочу узнать условия / Әзірге тек танысып отырмын, шарттарын білгім келеді",
  "Приготовить вместе в рамках академического сотрудничества / Академиялық серіктестік аясында бірге дайындау"
] as const;

export const BASES = [
  "Scopus",
  "Web of Science",
  "КОКСНВО (перечень рекомендованных изданий МНВО РК)",
  "Пока не знаю — нужна консультация / Әлі білмеймін — кеңес қажет"
] as const;

export const AREAS = [
  "Education / Pedagogy (Образование, педагогика)",
  "Linguistics & Language (Языкознание, прикладная лингвистика)",
  "Literature & Literary Theory (Литература, теория литературы)",
  "Communication & Media Studies (Коммуникации, медиа)",
  "Sociology / Social Sciences (Социология, социальные науки)",
  "Psychology (Психология)",
  "Law / Legal Studies (Право, юридические исследования)",
  "Public Administration / Political Science (Госуправление, политология)",
  "Cultural Studies / Anthropology (Культурология, антропология)",
  "Translation Studies (Переводоведение)",
  "Computer Science / AI in Humanities (ИТ/ИИ в гуманитарных науках)",
  "Interdisciplinary (междисциплинарно)"
] as const;

export const SUBJECTS = [
  "Linguistics & Language",
  "Applied Linguistics",
  "Sociolinguistics",
  "Psycholinguistics",
  "Cognitive Linguistics",
  "Corpus Linguistics",
  "Translation Studies",
  "Literature & Literary Theory",
  "Comparative Literature",
  "Cultural Studies",
  "Communication & Media Studies",
  "Education / Pedagogy",
  "Higher Education",
  "Language Education / TESOL",
  "Educational Technology",
  "Psychology",
  "Sociology / Social Sciences",
  "Law / Legal Studies",
  "Public Administration / Political Science",
  "Interdisciplinary Humanities & Social Sciences",
  "Другое"
] as const;

export const INDEXES = [
  "Scopus",
  "Web of Science Core Collection",
  "КОКСНВО / перечень МНВО РК",
  "РИНЦ / eLIBRARY.RU",
  "ERIC",
  "DOAJ",
  "Неиндексируемый рецензируемый научный журнал",
  "Материалы научной конференции",
  "Другой индекс / перечень"
] as const;

export const PERCENTILES = ['Не принципиально', '≥ 25', '≥ 50', '≥ 75', '≥ 90'] as const;

export const QUARTILES = ['Q1', 'Q2', 'Q3', 'Q4'] as const;

export const READINESS = [
  'Идея / план',
  'Тема + аннотация',
  'Материалы / данные собраны',
  'Черновик 50%+',
  'Полный черновик',
  'Полная рукопись готова',
  'Готова к подаче',
] as const;

export const REQUIREMENTS = [
  "Опыт публикаций Scopus / WoS",
  "Академический английский",
  "Статистический / количественный анализ",
  "Качественный анализ",
  "Работа с корпусом / данными",
  "Опыт corresponding author",
  "Институциональная аффилиация",
  "Готовность быстро предоставить author data"
] as const;

export type ProfileFieldType = 'text' | 'email' | 'url' | 'textarea';

export interface ProfileFieldDef {
  key: string;
  label: string;
  type: ProfileFieldType;
  placeholder?: string;
  help?: string;
  readonly?: boolean;
}

export const PROFILE_FIELDS: ProfileFieldDef[] = [
  {
    "key": "role",
    "label": "3.1 Роль и место в авторском составе / Авторлық құрамдағы рөл және орны",
    "type": "text",
    "placeholder": "Пример: второй автор и автор-корреспондент",
    "help": "Укажите вашу позицию и роль в авторском составе (если роль известна)."
  },
  {
    "key": "nameLocal",
    "label": "3.2 Ф.И.О. (полностью) — на казахском или русском языке",
    "type": "text",
    "placeholder": "Асылбеков Азамат Ахметович",
    "help": "Имя из зарегистрированного аккаунта подставляется автоматически."
  },
  {
    "key": "nameEn",
    "label": "3.3 Ф.И.О. на английском языке — строго как в паспорте",
    "type": "text",
    "placeholder": "Asylbekov Azamat",
    "help": "Латиницей, без сокращений и вольных вариантов написания."
  },
  {
    "key": "email",
    "label": "3.4 E-mail (основной / негізгі)",
    "type": "email",
    "placeholder": "name@gmail.com",
    "help": "Зарегистрированный e-mail подставляется автоматически."
  },
  {
    "key": "corporateEmail",
    "label": "3.5 Корпоративная электронная почта (если есть)",
    "type": "email",
    "placeholder": "name@university.kz",
    "help": "Официальный e-mail университета/организации."
  },
  {
    "key": "phone",
    "label": "3.6 Контактный номер телефона / WhatsApp",
    "type": "text",
    "placeholder": "+7 700 477 77 77",
    "help": "Номер для оперативной связи."
  },
  {
    "key": "specialty",
    "label": "3.7 Название и код специальности (шифр)",
    "type": "text",
    "placeholder": "8D04102 — Экономика",
    "help": "Официальное название специальности с кодом."
  },
  {
    "key": "orcid",
    "label": "3.8 Укажите ваш ORCID / ORCID нөміріңізді көрсетіңіз",
    "type": "url",
    "placeholder": "https://orcid.org/0000-0002-7814-1371",
    "help": "Если ORCID ещё нет, поле можно сохранить пустым и заполнить позже."
  },
  {
    "key": "scopus",
    "label": "3.9 Scopus Author ID (если имеется)",
    "type": "text",
    "placeholder": "55732569000",
    "help": "Если публикаций Scopus ещё не было, поле можно оставить пустым."
  },
  {
    "key": "wos",
    "label": "3.10 Профиль Web of Science (ResearcherID / Publons), если имеется",
    "type": "text",
    "placeholder": "NT-4233-2023",
    "help": "ResearcherID или ссылка на профиль."
  },
  {
    "key": "workLocal",
    "label": "3.11 Место работы полностью на казахском или русском языке",
    "type": "textarea",
    "placeholder": "Кафедра…, факультет…, университет…",
    "help": "Кафедра/подразделение, факультет/институт, официальное название организации."
  },
  {
    "key": "workEn",
    "label": "3.12 Место работы полностью на английском языке",
    "type": "textarea",
    "placeholder": "Department of…, Faculty of…, University…",
    "help": "Официальный английский вариант."
  },
  {
    "key": "addressLocal",
    "label": "3.13 Адрес организации и индекс на казахском или русском языке",
    "type": "textarea",
    "placeholder": "проспект…, город, индекс, страна",
    "help": "Улица/проспект, дом, город, индекс, страна."
  },
  {
    "key": "addressEn",
    "label": "3.14 Адрес организации и индекс на английском языке",
    "type": "textarea",
    "placeholder": "62 Zhenis Avenue, Astana, 010011, Kazakhstan",
    "help": "Тот же адрес на английском языке."
  },
  {
    "key": "positionLocal",
    "label": "3.15 Должность на казахском или русском языке",
    "type": "text",
    "placeholder": "старший преподаватель / научный сотрудник",
    "help": "Текущая должность в организации."
  },
  {
    "key": "positionEn",
    "label": "3.16 Должность на английском языке",
    "type": "text",
    "placeholder": "Senior Lecturer / Research Fellow",
    "help": "Официальный английский вариант должности."
  },
  {
    "key": "degreeLocal",
    "label": "3.17 Учёная степень на казахском или русском языке (если есть)",
    "type": "text",
    "placeholder": "магистр / PhD / кандидат наук / доктор наук / нет",
    "help": ""
  },
  {
    "key": "degreeEn",
    "label": "3.18 Учёная степень на английском языке (если имеется)",
    "type": "text",
    "placeholder": "PhD / Master’s degree / Candidate of Sciences / none",
    "help": ""
  },
  {
    "key": "titleLocal",
    "label": "3.19 Учёное звание на казахском или русском языке (если есть)",
    "type": "text",
    "placeholder": "доцент / профессор / нет",
    "help": ""
  },
  {
    "key": "titleEn",
    "label": "3.20 Учёное звание на английском языке (если есть)",
    "type": "text",
    "placeholder": "Associate Professor / Professor / none",
    "help": ""
  },
  {
    "key": "bio",
    "label": "3.21 Краткая биография (1 абзац, 6–7 предложений)",
    "type": "textarea",
    "placeholder": "Дата/место рождения, образование, место работы, опыт, интересы, проекты, публикации…",
    "help": "Заполняется при необходимости: некоторые журналы требуют краткую биографию автора."
  },
  {
    "key": "interests",
    "label": "3.22 Научные интересы / Ғылыми қызығушылықтарыңыз",
    "type": "textarea",
    "placeholder": "лингвистика, дискурс-анализ, терминология, академическое письмо",
    "help": "Укажите 5–10 ключевых интересов/направлений."
  },
  {
    "key": "message",
    "label": "3.23 Дополнительная информация, сообщение координатору",
    "type": "textarea",
    "placeholder": "Комментарий, уточнение или вопрос…",
    "help": "Можно писать на казахском или русском языке."
  }
];

export const PROFILE_FIELD_GROUPS = [
  { start: 0, end: 6, title: 'Идентификация и роль', desc: 'Роль, Ф.И.О., e-mail и телефон' },
  { start: 6, end: 10, title: 'Научные идентификаторы', desc: 'Специальность, ORCID, Scopus и Web of Science' },
  { start: 10, end: 16, title: 'Аффилиация', desc: 'Место работы, адрес и должность на двух языках' },
  { start: 16, end: 20, title: 'Степень и звание', desc: 'Учёная степень и академическое звание' },
  { start: 20, end: 23, title: 'Биография и научные интересы', desc: 'Биография, интересы и сообщение координатору' },
] as const;
